<script lang="ts">
export default {
  name: 'VirtualList',
};
</script>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useVirtualizer } from '@tanstack/vue-virtual';

const props = withDefaults(
  defineProps<{
    items: unknown[];
    rowHeight?: number;
  }>(),
  { rowHeight: 50 },
);

const scrollRef = ref<HTMLElement | null>(null);

const virtualizer = useVirtualizer(
  computed(() => ({
    count: props.items.length,
    getScrollElement: () => scrollRef.value,
    estimateSize: () => props.rowHeight,
    overscan: 5,
  })),
);
</script>

<template>
  <div
    ref="scrollRef"
    class="max-h-[680px] w-full min-w-0 overflow-y-auto">
    <div
      :style="{ height: `${virtualizer.getTotalSize()}px`, position: 'relative' }"
      class="w-full min-w-0">
      <div
        v-for="virtualRow in virtualizer.getVirtualItems()"
        :key="String(virtualRow.key)"
        :data-index="virtualRow.index"
        class="absolute top-0 right-0 left-0 w-full min-w-0"
        :style="{ transform: `translateY(${virtualRow.start}px)` }">
        <slot
          name="row"
          :item="items[virtualRow.index]"
          :index="virtualRow.index" />
      </div>
    </div>
  </div>
</template>
